import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { viewBox: "0 0 40 40" }

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "m18.3 8.7 1.4-1.4L32.4 20 19.7 32.7l-1.4-1.4L29.6 20 18.3 8.7zM19.6 20 8.3 31.3l1.4 1.4L22.4 20 9.7 7.3 8.3 8.7 19.6 20z" }, null, -1)
  ])))
}
export default { render: render }